import Vue from "vue";

import RtHeader from "../packages/header/src/main";
import RtContent from "../packages/content/src/main";
import RtToolbar from "../packages/toolbar/src/main";
import RtQuery from "../packages/query/src/main";
import RtGrid from "../packages/grid/src/main";
import RtPicklist from "../packages/picklist/src/main";
import RtSoButton from "../packages/button/src/main";
import RtSection from "../packages/section/src/main";
import RtNav from "../packages/nav/src/nav";
import RtNavItem from "../packages/nav/src/nav-item";
import RtPortalIcon from "../packages/icon/index";
//Lookup
import RtSoLookup from "../packages/lookup/src/lookup";
import RtSooLookup from "../packages/lookup/src/lookup2";
import RtLookupDialog from "../packages/lookup/src/lookup-dialog";

//lookup
import RtNewLookup from "../packages/newlookup/src/lookup";
import RtNewLookupDialog from "../packages/newlookup/src/lookup-dialog";

//Excel导入
import RtExcelImportDialog from "../packages/excel-import/src/excel-import-dialog";
import RtExcelImport from "../packages/excel-import/src/excel-import";
//流程提交
import RtFlowSubmitDialog from "../packages/flow/src/submit-dialog";
//审批进度
import RtApprovalProgress from "../packages/approval/src/progress";
import RtApprovalProgressDialog from "../packages/approval/src/progress-dialog";

import RtFileList from "./file/src/file-list";
import XpcComponents from "vue-xpc/src/components";

var components = [
  // RtHeader,
  // RtContent,
  // RtToolbar,
  // RtQuery,
  // RtGrid,
  // RtPicklist,
  RtSoButton,
  // RtSection,
  RtNav,
  RtNavItem,
  RtSoLookup,
  RtSooLookup,
  RtLookupDialog,
  RtExcelImportDialog,
  RtExcelImport,
  RtFlowSubmitDialog,
  RtApprovalProgress,
  RtApprovalProgressDialog,
  RtFileList,
  RtPortalIcon,
  RtNewLookup,
  RtNewLookupDialog
];

export default {
  install: function (Vue, opts) {
    components.map(function (component) {
      Vue.component(component.name, component);
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./packages/index.js
// module id = 2282
// module chunks = 137